import httpClient from '@/lib/httpClient'
import { useMutation, useQuery } from '@tanstack/react-query'

/**
 * Space data reset endpoints (14zfmu10f5p). Every call targets the given
 * space explicitly and skips the global error toasts — the modal renders each
 * error state itself.
 */

export interface SpaceResetPreview {
  delete: {
    transactions: number
    recurring_series: number
    money_paths: number
    models: number
  }
  keep: { vaults: number; categories: number }
}

export interface SpaceResetRequest {
  audit_log_id: string
  expires_at: string
}

const config = (teamId: number | string) => ({
  headers: { 'X-Team': teamId },
  silentErrors: true,
})

export function useSpaceResetPreview(teamId: number | string, enabled: boolean) {
  return useQuery<SpaceResetPreview>({
    queryKey: ['space-reset-preview', teamId],
    queryFn: async () =>
      (await httpClient.get('team/reset/preview', config(teamId))).data,
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  })
}

export function useRequestSpaceReset(teamId: number | string) {
  return useMutation<SpaceResetRequest, any, void>({
    mutationFn: async () =>
      (await httpClient.post('team/reset/request', {}, config(teamId))).data,
  })
}

export function useConfirmSpaceReset(teamId: number | string) {
  return useMutation<
    any,
    any,
    {
      audit_log_id: string
      code: string
      acknowledgement_version: string
    }
  >({
    mutationFn: async (body) =>
      (
        await httpClient.post(
          'team/reset/confirm',
          { ...body, acknowledged: true },
          config(teamId),
        )
      ).data,
  })
}
